export function eachFigures(cb) {
    for (var i = 0; i < 81; i += 9)
        cb([i, i + 1, i + 2, i + 3, i + 4, i + 5, i + 6, i + 7, i + 8]);
    for (var i = 0; i < 9; i++)
        cb([i, i + 9, i + 18, i + 27, i + 36, i + 45, i + 54, i + 63, i + 72]);
    for (var _i = 0, _a = [0, 3, 6, 27, 30, 33, 54, 57, 60]; _i < _a.length; _i++) {
        var i = _a[_i];
        cb([i, i + 1, i + 2, i + 9, i + 10, i + 11, i + 18, i + 19, i + 20]);
    }
}
